import ng from 'angular';
import { AccountModelService, AuthContextService } from '@/services';
import { AccountApi } from '@/types/account-api';
import { BundleApi } from '@/types/bundle-api';

export class OrganismEditFormBundleExtensionsController {
    public static $inject: string[] = ['accountModel'];

    public bundle: BundleApi.BundleDetails;
    public bundleUpgradeInfo: BundleApi.BundleUpgradeInfo;
    public allowedContingentExtensions: BundleApi.BundleContingentExtension[];
    public bundleAccount: AccountApi.Account | AccountApi.Subaccount;

    constructor(private accountModel: AccountModelService) {}

    public $onInit = (): void => {
        this.allowedContingentExtensions = this.bundleUpgradeInfo.allowedContingentExtensions || [];

        if (this.bundle.accountId && this.bundle.accountId !== AuthContextService.account.id) {
            void this.accountModel.findOne(this.bundle.accountId).then((result) => {
                this.bundleAccount = result;
            });
        } else {
            this.bundleAccount = AuthContextService.account;
        }
    };
}

export class OrganismEditFormBundleExtensionsComponent implements ng.IComponentOptions {
    public bindings = {
        bundle: '<',
        bundleUpgradeInfo: '<',
    };
    public controller = OrganismEditFormBundleExtensionsController;
    public template = require('./bundle-extensions.html');
}
